export const FormType = {
    create: 'create',
    modify: 'modify',
}